import Cookie from "js-cookie";
import ahoy from "ahoy.js";

// configure ahoy to not use cookies
ahoy.configure({ cookies: false });

class WildCart {
  constructor() {
    this.tldn = location.host;
    this.protocol = window.location.protocol;
    this.baseUrl = `${this.protocol}//${this.tldn}`;
    this.addToCartUrl = `${this.baseUrl}/users/products/add_to_cart`;
    this.getCartUrl = `${this.baseUrl}/users/products/get_cart`;
    this.cart = {};
    this.cartTotals = {};
    this.cartSubscribers = [];
  }

  updateCart(cart) {
    this.cart = cart;
    this.updateCartTotals(cart);

    this.cartSubscribers.forEach((subscriber) => {
      subscriber.cartUpdated({
        cart: this.cart,
        cartTotals: this.cartTotals,
      });
    });
  }

  updateCartTotals(cart) {
    let cartCount = 0;
    this.cartTotals.items = 0;

    for (const pid in cart) {
      const qty = parseInt(cart[pid].qty, 10);
      this.cartTotals.items += qty;
      cartCount += qty;
    }

    Cookie.set("cart_count", cartCount, {
      path: "/",
      domain: this.tldn.replace("learn", ""),
    });
  }

  subscribe(subscriber) {
    this.cartSubscribers.push(subscriber);
  }

  unsubscribe(subscriber) {
    const index = this.cartSubscribers.indexOf(subscriber);
    if (index !== -1) {
      this.cartSubscribers.splice(index, 1);
    }
  }
}

class AddToCart {
  constructor(element, options = {}) {
    this.element = element;
    this.wildCart = options.wildCart;

    this.options = {
      qty: 1,
      successTemplate: "Added to cart!",
      onAdded: () => console.warn("No onAdded callback provided"),
      updateCart: (cart) => this.wildCart.updateCart(cart),
      ...options,
    };

    this.pid = element.dataset.pid;
    this.quantity = element.dataset.qty;
    this.price = element.dataset.price;
    this.name = element.dataset.name;
    this.multiAdd = element.dataset.multiAdd;

    if (element.dataset.qtySource) {
      const qtyElement = document.querySelector(element.dataset.qtySource);
      this.qty = qtyElement ? qtyElement.value : 1;
    } else if (element.dataset.qty) {
      this.qty = element.dataset.qty;
    } else {
      this.qty = this.options.qty;
    }

    this.element.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.ajaxAdd();
  }

  ajaxAdd() {
    const data = {
      action: "add_to_cart",
      multi_add: this.multiAdd,
      pid: this.pid,
      qty: this.qty,
      source_page: "learn",
      url: window.location.href,
      guide_id: parseInt(
        document.querySelector("[data-guide-id]")?.dataset?.guideId,
        10,
      ),
      page_id: parseInt(
        document.querySelector("[data-page-id]")?.dataset?.pageId,
        10,
      ),
    };

    const token = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    fetch(this.wildCart.addToCartUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": token,
      },
      credentials: "include",
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Add To Cart Error: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => {
        if (localStorage) {
          localStorage.removeItem("cache-learn-cart");
        }

        ahoy.track("learn:addToCart", data);

        if (data.zenid) {
          Cookie.set("zenid", data.zenid, {
            path: "/",
            domain: this.wildCart.tldn.replace("learn", ""),
          });
        }

        this.options.onAdded(data);
        this.options.updateCart(data.cart);
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      });
  }

  destroy() {
    this.element.removeEventListener("click", this.handleClick.bind(this));
  }
}

class ShoppingCartTag {
  constructor(element, options = {}) {
    this.element = element;
    this.wildCart = options.wildCart;

    this.options = {
      cartUpdated: () => console.warn("No cartUpdated callback provided"),
      ...options,
    };

    this.cartUpdated = this.options.cartUpdated.bind(this);
    this.wildCart.subscribe(this);
  }

  destroy() {
    this.wildCart.unsubscribe(this);
  }
}

// singleton instance of WildCart
const wildCart = new WildCart();

export { wildCart, AddToCart, ShoppingCartTag };
